module.exports = __webpack_public_path__ + "img/tjtp.8df979a0.png";